// PHASE-2.01 START
'use client';
import * as React from 'react';

export function DropdownItem({ onSelect, children }:{ onSelect:()=>void; children:React.ReactNode }){
  return <button role="menuitem" className="h-11 px-3 rounded-lg w-full text-left hover:bg-muted/60" onClick={onSelect}>{children}</button>;
}
// PHASE-2.01 END

